/* Shopify /policies/* pages: tidy the Word-pasted policy text and give it real structure.
   The admin text marks headings as a bold run at the start of a paragraph; each becomes a
   <section> with an <h2>, and three or more headings get an "On this page" index. */
(function () {
  const container = document.querySelector('.shopify-policy__container');
  const rte = container && container.querySelector('.shopify-policy__body .rte');
  if (!rte || rte.classList.contains('policy-rte--built')) return;

  // Word leftovers: inline styles, MsoNormal, empty wrappers, presentational spans
  rte.querySelectorAll('[style]').forEach((el) => el.removeAttribute('style'));
  rte.querySelectorAll('.MsoNormal').forEach((el) => {
    el.classList.remove('MsoNormal');
    if (!el.classList.length) el.removeAttribute('class');
  });
  rte.querySelectorAll('span, u').forEach((el) => el.replaceWith(...el.childNodes));
  rte.querySelectorAll('b, strong, ins, em, i').forEach((el) => {
    if (!el.textContent.trim() && !el.querySelector('img')) el.remove();
  });

  const isBlank = (node) =>
    (node.nodeType === Node.TEXT_NODE && !node.textContent.trim()) || node.nodeName === 'BR';

  const leadingBold = (p) => {
    if (p.nodeName !== 'P') return null;
    let node = p.firstChild;
    while (node && isBlank(node)) node = node.nextSibling;
    return node && (node.nodeName === 'B' || node.nodeName === 'STRONG') && node.textContent.trim() ? node : null;
  };

  // The admin text repeats the page title as its first line
  const first = rte.firstElementChild;
  const firstBold = first && leadingBold(first);
  if (firstBold && first.textContent.trim() === firstBold.textContent.trim() && /policy/i.test(first.textContent)) {
    first.remove();
  }

  const slugs = new Set();
  const slugify = (text) => {
    const base =
      text
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '') || 'section';
    let slug = base;
    for (let n = 2; slugs.has(slug) || document.getElementById(slug); n++) slug = `${base}-${n}`;
    slugs.add(slug);
    return slug;
  };

  const sections = [];
  let current = null;
  const startSection = (title) => {
    current = document.createElement('section');
    current.className = 'policy-section';
    if (title) {
      const h2 = document.createElement('h2');
      h2.className = 'policy-section__title';
      h2.id = slugify(title);
      h2.textContent = title;
      current.setAttribute('aria-labelledby', h2.id);
      current.appendChild(h2);
    } else {
      current.classList.add('policy-section--lead');
    }
    sections.push(current);
  };

  // Shopify's generated policies (privacy, terms) already use real headings, sometimes from <h1>.
  // Section on the top level present and move the levels below it up under the new <h2>s.
  const topHeading = rte.querySelector(':scope > h1') ? 'H1' : 'H2';
  if (topHeading === 'H1') {
    rte.querySelectorAll('h2, h3').forEach((h) => {
      const lower = document.createElement(h.nodeName === 'H2' ? 'h3' : 'h4');
      lower.append(...h.childNodes);
      h.replaceWith(lower);
    });
  }

  Array.from(rte.childNodes).forEach((node) => {
    if (node.nodeName === topHeading && node.textContent.trim()) {
      startSection(node.textContent.replace(/\s+/g, ' ').trim());
      return;
    }
    const bold = leadingBold(node);
    if (bold) {
      const title = bold.textContent.replace(/\s+/g, ' ').trim().replace(/:$/, '');
      bold.remove();
      while (node.firstChild && isBlank(node.firstChild)) node.firstChild.remove();
      startSection(title);
      if (node.textContent.trim() || node.querySelector('img')) current.appendChild(node);
      return;
    }
    if (isBlank(node)) return;
    if (node.nodeName === 'P' && !node.textContent.trim() && !node.querySelector('img')) return;
    if (!current) startSection(null);
    current.appendChild(node);
  });

  rte.replaceChildren(...sections);
  rte.classList.add('policy-rte--built');

  const headings = sections.map((s) => s.querySelector('.policy-section__title')).filter(Boolean);
  if (headings.length < 3) return;

  const nav = document.createElement('nav');
  nav.className = 'policy-index';
  nav.setAttribute('aria-labelledby', 'PolicyIndexTitle');
  nav.innerHTML = '<h2 class="policy-index__title" id="PolicyIndexTitle">On this page</h2><ul class="policy-index__list"></ul>';
  const list = nav.querySelector('ul');
  const links = new Map();
  headings.forEach((h2) => {
    const li = document.createElement('li');
    const a = document.createElement('a');
    a.className = 'policy-index__link';
    a.href = `#${h2.id}`;
    a.textContent = h2.textContent;
    li.appendChild(a);
    list.appendChild(li);
    links.set(h2.id, a);
  });

  container.prepend(nav);
  container.classList.add('policy-has-index');
  const help = document.querySelector('.policy-help');
  if (help) help.classList.add('policy-help--indented');

  if (!('IntersectionObserver' in window)) return;
  const visible = new Set();
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const id = entry.target.getAttribute('aria-labelledby');
        if (entry.isIntersecting) visible.add(id);
        else visible.delete(id);
      });
      const active = headings.find((h2) => visible.has(h2.id));
      if (!active) return;
      links.forEach((a, id) => {
        if (id === active.id) a.setAttribute('aria-current', 'true');
        else a.removeAttribute('aria-current');
      });
    },
    { rootMargin: '-120px 0px -55% 0px' }
  );
  sections.forEach((s) => s.hasAttribute('aria-labelledby') && observer.observe(s));
})();
